/**
 * Created by Mark on 24/11/2016.
 */


import AppDispatcher from './applciation-dispatcher.js';

export default{

    update(action , data){
        AppDispatcher.dispatch({actionType:action , response:data});
    },
}